import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_REVENUE_LIST = 'GET_REVENUE_LIST';
export const GET_REVENUE_LIST_SUCCESS = 'GET_REVENUE_LIST_SUCCESS';
export const GET_REVENUE_LIST_FAILURE = 'GET_REVENUE_LIST_FAILURE';

// Action Creators
export const getRevenueList = () => ({
  type: GET_REVENUE_LIST,
});

export const getRevenueListSuccess = (users) => ({
  type: GET_REVENUE_LIST_SUCCESS,
  payload: users,
});

export const getRevenueListFailure = (error) => ({
  type: GET_REVENUE_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getRevenueListCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(getRevenueList());
    try {
      const response = await getMethodWithToken(url.revenueStream + data);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getRevenueListSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getRevenueListFailure(error?.message));
    }
  };
};
